import {BehaviorSubject} from 'rxjs';
import {IdBase} from '../interfaces';
import {CollectionData} from './collection.data';

export class IsLoadingData<T extends IdBase<IdType>, IdType = number> extends CollectionData<T, IdType> {
  private _isLoading$ = new BehaviorSubject<boolean>(false);

  get isLoading$() {
    return this._isLoading$.asObservable();
  }

  peekIsLoading(): boolean {
    return this._isLoading$.value;
  }

  pokeIsLoading(isLoading: boolean): void {
    this._isLoading$.next(isLoading);
  }
}
